/**
 * 双重预防机制 - 报表分析 API
 * 包括：风险台账统计、自检结果统计、抽检结果统计、设备检验统计
 */
import request from "@/utils/enhancedRequest";

// ==================== 风险台账统计 ====================



/**
 * 按风险等级统计风险点位
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getRiskPointByLevel(data) {
  return request({
    url: `/sa/green/pre/risk-point/statistics/risk-level`,
    method: "post",
    data,
  });
}

/**
 * 按检测频次统计风险点位
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getRiskPointByFrequency(data) {
  return request({
    url: `/sa/green/pre/risk-point/statistics/frequency`,
    method: "post",
    data,
  });
}

// ==================== 自检结果统计 ====================

/**
 * 获取自检结果统计数据
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getSelfInspectionStatistics(data) {
  return request({
    url: `/sa/safety/report/selfInspectionStatistics`,
    method: "post",
    data,
  });
}

/**
 * 获取自检结果按状态统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getSelfInspectionByStatus(data) {
  return request({
    url: `/sa/safety/report/selfInspectionByStatus`,
    method: "post",
    data,
  });
}

/**
 * 获取自检结果按部门统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getSelfInspectionByDepartment(data) {
  return request({
    url: `/sa/safety/report/selfInspectionByDepartment`,
    method: "post",
    data,
  });
}

/**
 * 导出自检结果统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportSelfInspectionStatistics(data) {
  return request({
    url: `/sa/safety/report/selfInspectionStatistics/export`,
    method: "post",
    data,
  });
}

/**
 * 自检结果统计导出（按点位）
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportSelfInspectionByPoint(data) {
  return request({
    url: `/sa/green/pre/risk-point-tasks/export/by-point`,
    method: "post",
    data,
  });
}

/**
 * 获取自检结果统计总数
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getSelfInspectionTotalStatistics(data) {
  return request({
    url: `/sa/green/pre/risk-point-tasks/statistics/total`,
    method: "post",
    data,
  });
}

/**
 * 获取自检结果按点位统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getSelfInspectionByPoint(data) {
  return request({
    url: `/sa/green/pre/risk-point-tasks/statistics/by-point`,
    method: "post",
    data,
  });
}

// ==================== 抽检结果统计 ====================



/**
 * 按时间统计抽检结果
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getOverallStatistics(data) {
  return request({
    url: `/sa/green/pre/risk-point-sampling-tasks/overallStatistics`,
    method: "post",
    data,
  });
}

/**
 * 统计抽检任务按点位
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getPointStatistics(data) {
  return request({
    url: `/sa/green/pre/risk-point-sampling-tasks/pointStatistics`,
    method: "post",
    data,
  });
}

/**
 * 获取抽检结果按状态统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getSamplingByStatus(data) {
  return request({
    url: `/sa/safety/report/samplingByStatus`,
    method: "post",
    data,
  });
}

/**
 * 获取抽检结果按部门统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getSamplingByDepartment(data) {
  return request({
    url: `/sa/safety/report/samplingByDepartment`,
    method: "post",
    data,
  });
}

/**
 * 导出抽检结果统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportSamplingStatistics(data) {
  return request({
    url: `/sa/safety/report/samplingStatistics/export`,
    method: "post",
    data,
  });
}

/**
 * 抽检结果统计导出（按点位）
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportSamplingPointStatistics(data) {
  return request({
    url: `/sa/green/pre/risk-point-sampling-tasks/export/pointStatistics`,
    method: "post",
    data,
  });
}

// ==================== 设备检验统计 ====================

/**
 * 获取设备检验统计数据
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getDeviceInspectionStatistics(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/statistics`,
    method: "post",
    data,
  });
}



/**
 * 导出设备检验统计
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportDeviceInspectionStatistics(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/statistics/export`,
    method: "post",
    data,
  });
}

